import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { papillionConfig } from "./data";

export default function PapillionPage() {
  return <CityPageTemplate config={papillionConfig} />;
}